<style lang="scss">
  .button-group {
    &__buttons {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
    }

    &__button {
      background-color: white;
      font-size: 14px;
      line-height: 1;
      padding: 7px 10px;
      cursor: pointer;

      border-color: color(grey-border);
      border-style: solid;
      border-top-width: 1px;
      border-right-width: 1px;
      border-bottom-width: 1px;

      &:first-child {
        border-left-width: 1px;

        padding-left: 12px;
        border-top-left-radius: 14px;
        border-bottom-left-radius: 14px;
      }

      &:last-child {
        padding-right: 12px;
        border-top-right-radius: 14px;
        border-bottom-right-radius: 14px;
      }

      &:hover {
        color: color(accent);
      }
    }
  }
</style>

<template>
  <div class="button-group">
    <ul class="button-group__buttons">
      <li
        v-for="button in buttons"
        :key="button.value"
        class="button-group__button"
        @click.prevent="clickButton(button)"
      >
        <span>{{ button.label }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'VButtonGroup',
  props: {
    buttons: {
      type: Array,
      required: true,
    },
  },
  methods: {
    clickButton(button) {
      this.$emit('selected', button);
    },
  },
};
</script>
